var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choice-vote"},[_c('choice-vote-content',{attrs:{"items":_vm.items}}),(_vm.showMoreRank)?_c('div',{staticClass:"mt-4"},[_c('van-button',{attrs:{"size":"small","block":"","plain":"","type":"primary"},on:{"click":_vm.onShowMoreRank}},[_vm._v("查看更多排名")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }